import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UntilDestroy } from '@ngneat/until-destroy';

export const STATUS_PAGE_URL = 'https://status.uptrends.com/20c36165ef574f32bf48441b78b7508e/';

@UntilDestroy()
@Component({
  selector: 'hk-status-overview',
  templateUrl: 'status-overview.component.html',
  host: { class: 'flex flex-1 flex-col ' },
})
export class StatusOverviewComponent implements OnInit {
  public statusPageSafeResourceUrl!: SafeResourceUrl;

  constructor(private _sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.statusPageSafeResourceUrl = this._sanitizer.bypassSecurityTrustResourceUrl(STATUS_PAGE_URL);
  }
}
